import common from './common'

const portfolio = {
  ...common.button,
  color: `white`,
  bg: `alpha`,
  borderColor: `alpha`,
  borderWidth: `md`,
  borderStyle: `solid`,
  ':hover': {
    color: `omegaLighter`,
    bg: `omegaDark`,
    borderColor: `omegaDark`
  },
  gap: 2,
  mb: 3
}

export default portfolio